module.exports = __webpack_public_path__ + "img/tutorial_war_09.3deff044.gif";